/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    ClientWebSocketService: {
        applicationWasUpdated: {
            link: "Cliquez ici pour recharger l'application.",
            title: "L'application a été mise à jour"
        },
        sessionTerminated: {
            link: "Cliquez ici pour recharger l'application.",
            title: "Votre session a été interrompue"
        }
    },
    ConnectionsListPage: {
        connectTS: "Socket",
        displayName: "Nom",
        navigationTS: "Navigation",
        page: "Page courante",
        rooms: "Salle(s)",
        serverInstanceUid: "Serveur",
        sessionTS: "Session",
        userUid: "Identifiant"
    }
};